import {
  field,
  getFirstArrayValue,
  getFirstSemicolonSeparatedValue,
  getSemicolonSeparatedValues,
} from "../../helpers";
import { pubmedTheme } from "../themes";

const pubmedConfig = {
  label: "PubMed",
  theme: pubmedTheme,
  summary: {
    primary: field("Title", ["Title"]),
    secondary: field("PMID", ["PMID"], { kind: "id" }),
    columns: [
      field("Authors", ["Authors"], {
        className: "hidden lg:block flex-[1.5] min-w-[11rem]",
        formatValue: getFirstSemicolonSeparatedValue,
      }),
      field("Journal", ["Journal"], {
        className: "hidden md:block flex-[1.1] min-w-[8rem]",
      }),
      field("Year", ["Publication_Year", "Publication_Date"], {
        className: "flex-[0.6] min-w-[5rem]",
      }),
    ],
  },
  detail: {
    meta: [
      field("PMID", ["PMID"], { kind: "id" }),
      field("PMCID", ["PMCID"], { kind: "accent" }),
      field("Publication date", ["Publication_Date"]),
    ],
    sections: [
      {
        title: "Publication",
        fields: [
          field("Title", ["Title"]),
          field("Journal", ["Journal"]),
          field("Publication date", ["Publication_Date"]),
        ],
      },
      {
        title: "Authors",
        fields: [
          field("Author list", ["Authors"], {
            formatValue: getSemicolonSeparatedValues,
            kind: "multi-badge",
            itemKind: "accent",
          }),
          field("Affiliations", ["Author_Affiliations_List"], {
            formatValue: getFirstArrayValue,
          }),
        ],
      },
      {
        title: "Content",
        fields: [
          field("Abstract", ["Abstract"]),
          field("MeSH terms", ["MeSH_Terms"], {
            kind: "multi-badge",
            itemKind: "accent",
            formatValue: getSemicolonSeparatedValues,
          }),
          field("Publication type", ["Publication_Types"], {
            kind: "multi-badge",
            itemKind: "accent",
            formatValue: getSemicolonSeparatedValues,
          }),
        ],
      },
      {
        title: "Access",
        fields: [
          field("DOI", ["DOI"], {
            kind: "link",
            buildHref: (record, value) => (value ? `https://doi.org/${value}` : ""),
          }),
          field("Open access", ["PMCID"], {
            kind: "status",
            formatValue: () => "PMC Available",
          }),
        ],
      },
      {
        title: "sources",
        fields: [
          field("source", ["source_names"]),
        ],
      },
    ],
    links: [
      {
        label: "PubMed",
        buildHref: (record, value) =>
          value ? `https://pubmed.ncbi.nlm.nih.gov/${value}/` : "",
        sources: ["PMID"],
        valueLabel: "Open in PubMed",
      },
      {
        label: "PMC",
        buildHref: (record, value) =>
          value ? `https://pmc.ncbi.nlm.nih.gov/articles/${value}/` : "",
        sources: ["PMCID"],
        valueLabel: "Open in PMC",
      },
      {
        label: "ClinicalTrials.gov",
        buildHref: (record, value) =>
          value ? `https://clinicaltrials.gov/ct2/show/${value}` : "",
        sources: ["ClinicalTrials_IDs"],
        valueLabel: "Open in ClinicalTrials.gov",
      },
    ],
  },
};

export default pubmedConfig;
